import VueCookies from 'vue-cookies'
import {
    isFirstLogin,
    jpGetClass,
    jpGetUserInfo,
    jpStuGetClass
} from "@/api/jpApi.js";
import {
    getPrice
} from "@/page/teacher/personalCenter/index/indexApi.js";
export default {
    state: {
        class_id: VueCookies.get("class_id"),
        is_valid: true,
        is_jp_account: false,
        has_paid_student: false,
        is_free: false,
        is_spoken_valid: true,
        is_first_login: false,
        first_login_teacher_info: {
            student_count: "",
            jp_url: "",
        }, // jp教师首次登录信息
        jp_account_renew_info: {}, //
        jp_teacher_renew_price: {}, // 续班价格
    },

    getters: {
        isJpAccountAndExpired: state => {
            return state.is_jp_account && !state.is_valid
            // // 过期隐藏功能
            // if (VueCookies.get("user_type") == 1) {
            //     return (state.is_jp_account && !state.is_valid) || (state.is_jp_account && state.is_valid && !state.is_free && !state.has_paid_student)
            // }
            // return state.is_jp_account && !state.is_valid
        },
        isJpAccountAndFirstLogin: state => {
            return state.is_first_login
        },
        jpAccountTeacherInfo: state => {
            return state.first_login_teacher_info
        },
        getJpTeacherRenewPrice: state => {
            return state.jp_teacher_renew_price
        },
        getJpAccountRenewInfo: state => {
            return state.jp_account_renew_info
        },
        getJpSpokenDisabled: state => {
            return state.is_jp_account && !state.is_spoken_valid
        },
    },
    mutations: {
        SET_JP_ACCCOUNT_INFO: (state, data) => {
            state.is_jp_account = data.org_code == "jp";
            state.is_spoken_valid = data.is_spoken_valid;
            state.is_valid = data.is_valid;
            state.has_paid_student = data.has_paid_student;
            state.is_free = data.is_free;
        },
        SET_JP_ACCCOUNT_LOGIN_INFO: (state, data) => {
            state.is_first_login = data.is_first_login;
            state.first_login_teacher_info = {
                "student_count": data.student_count,
                "jp_url": data.jp_url,
            };
        },
        SET_JP_TEACHER_RENEW_PRICE: (state, data) => {
            state.jp_teacher_renew_price = data;
        },
        SET_JP_ACCOUNT_RENEW_INFO: (state, data) => {
            state.jp_account_renew_info = data;
        },
    },
    actions: {
        // 是否为第一次登陆
        CHECK_JP_IS_FIRST_LOGIN({
            commit
        }, data) {
            isFirstLogin(data)
                .then(res => {
                    if (res.errCode == 0) {
                        // 是首次登陆 强制设置密码
                        commit('SET_JP_ACCCOUNT_LOGIN_INFO', {
                            is_first_login: res.data.status,
                            student_count: res.data.student_count,
                            jp_url: res.data.jp_url,
                        });
                    }
                })
                .catch(err => {
                    throw new Error(err);
                });
        },
        // 班级续费信息 
        CHECK_JP_RENEW_IFNO({
            commit,
            state
        }, data) {
            // 账号过期信息 用来控制过期隐藏清单
            jpGetUserInfo(data).then(res => {
                    console.log("查账号过期信息,is_valid=", res.data.is_valid)
                    if (res.errCode == 0) {
                        commit('SET_JP_ACCCOUNT_INFO', res.data);
                    }
                })
                .catch(err => {
                    throw new Error(err);
                });


            //用来 显示右上角续费信息
            if (VueCookies.get("user_type") == 1) {
                // 教师当前班级续费信息
                data = {
                    class_id: data.class_id || VueCookies.get("jp_teacher_class_id") || VueCookies.get("class_id")
                }
                jpGetClass(data)
                    .then(res => {
                        if (res.errCode == 0) {
                            console.log("教师：", res.data);
                            commit('SET_JP_ACCOUNT_RENEW_INFO', res.data);
                        }
                    })
                    .catch(err => {
                        throw new Error(err);
                    });

                //获取价格
                if (JSON.stringify(state.jp_teacher_renew_price) != '{}') {
                    return;
                }
                getPrice()
                    .then(res => {
                        if (res.errCode == 0) {
                            commit('SET_JP_TEACHER_RENEW_PRICE', res.data);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }

            if (VueCookies.get("user_type") == 2) {
                // 学生当前续费信息
                jpStuGetClass()
                    .then(res => {
                        if (res.errCode == 0) {
                            console.log("学生：", res.data);
                            commit('SET_JP_ACCOUNT_RENEW_INFO', res.data);
                        }
                    })
                    .catch(err => {
                        throw new Error(err);
                    });
            }



        },
        // 移除jp账号续费信息
        REMOVE_JP_RENEW_INFO({
            commit
        }, data) {
            commit('SET_JP_ACCOUNT_RENEW_INFO', {});
        },

    }
}